import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../../Common/Loader";
import MultiSelectDropdown from "../../Common/MultiSelectDropdown";
import { nameWithNumberValidation } from "../../Common/Validations";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { createContactGroup } from "../../Redux/Slice/Contacts/Contact Group/CreateContactGroupSlice";
import { getContactGroupById } from "../../Redux/Slice/Contacts/Contact Group/GetContactGroupByIdSlice";
import { updateContactGroup } from "../../Redux/Slice/Contacts/Contact Group/UpdateContactGroupSlice";
import { getContactList } from "../../Redux/Slice/Contacts/GetContactsListSlice";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";

export const AddGroup = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formError, setFormError] = useState({
    groupNameError: "",
  });
  const [formData, setFormData] = useState({
    groupName: "",
    status: true,
  });
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedAssistants, setSelectedAssistants] = useState([]);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState("");
  const [hasChangedModel, setHasChangedModel] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isEditGroup = location.pathname.includes("edit-group");
  const groupId = isEditGroup ? location.pathname.split("/")[2] : "";
  const contactsList = useSelector((state) => state.contacts.ContactsList);
  const assistantList = useSelector(
    (state) => state?.assistants?.assistantsList
  );

  const formatedMembersList = useMemo(() => {
    let _formatedDataList = Array.isArray(contactsList?.data)
      ? contactsList?.data?.map((contact) => {
          return {
            value: contact?.id,
            label: `${contact?.firstName} ${contact?.lastName}`,
          };
        })
      : [];
    return _formatedDataList;
  }, [contactsList]);

  const formattedAssistantList = useMemo(() => {
    let _formattedDataList = Array.isArray(assistantList?.data)
      ? assistantList?.data?.map((assistant) => {
          return { value: assistant?.id, label: assistant?.name };
        })
      : [];
    return _formattedDataList;
  }, [assistantList, assistantList?.data]);

  const handleChangeAssistantListData = (selectedList) => {
    const selectedListIds = Array.isArray(selectedList)
      ? selectedList.map((item) => item?.value)
      : [];
    setSelectedAssistants(selectedListIds);
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
  };

  const handleChangeMembers = (selectedList) => {
    const selectedListIds = Array.isArray(selectedList)
      ? selectedList.map((item) => item?.value)
      : [];

    setSelectedMembers(selectedListIds);
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
  };

  const handleChange = (e) => {
    let { value, name, checked } = e.target;
    if (name == "groupName") {
      value = value?.trimStart();
      const isValid = nameWithNumberValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, groupNameError: "" });
      } else {
        setFormError({
          ...formError,
          groupNameError:
            "Name can only contain letters, numbers, spaces, hyphens, and apostrophes",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name == "status") {
      setFormData({ ...formData, status: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
  };
  const getGroupDetails = async () => {
    setIsLoading(true);
    const result = await dispatch(getContactGroupById(groupId));
    if (
      getContactGroupById.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      const ids = Array.isArray(result?.payload?.data?.contacts)
        ? result.payload.data?.contacts?.map((i) => i?.id)
        : [];
      setSelectedMembers(ids);
      setFormData({
        ...formData,
        groupName: result?.payload?.data?.name,
        status: result?.payload?.data?.isActive,
      });
      setSelectedAssistants(
        Array.isArray(result?.payload?.data?.assistant)
          ? result?.payload?.data?.assistant?.map((assistant)=> assistant?.vapiAssistanceId)
          : []
      );
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  useEffect(() => {
    if (groupId) {
      getGroupDetails();
    }
  }, [groupId]);

  useEffect(() => {
    dispatch(getContactList({ searchText: "", page: 1, limit: 1000 }));
    dispatch(getAssistantList({ text: "", isDropdown: true }));
  }, []);

  const handleCancel = () => {
    dispatch(setUnsavedChanges(false));
    setCOnfirmModel(false);
    navigate(-1);
  };

  const onClickCancel = () => {
    if (hasChanged) {
      setHasChangedModel(true);
    } else {
      handleCancel();
    }
  };

  const handleUpdate = async () => {
    setCOnfirmModel(false);
    setIsLoading(true);
    let payload = {
      name: formData.groupName,
      isActive: formData.status,
      contactIds: selectedMembers,
      assistantIds: selectedAssistants,
    };
    const result = await dispatch(
      updateContactGroup({ id: groupId, payload: payload })
    );
    if (
      updateContactGroup.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Group Updated Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };
  const handleSubmit = async () => {
    if (!isEditGroup) {
      setIsLoading(true);
      let data = {
        name: formData.groupName,
        isActive: formData.status,
        contactIds: selectedMembers,
        assistantIds: selectedAssistants,
      };
      dispatch(setUnsavedChanges(false));
      const result = await dispatch(createContactGroup(data));
      if (
        createContactGroup.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        setSuccessMessage("Group Created Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
          navigate(-1);
        }, 1500);
      } else {
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } else {
      setCOnfirmModel(true);
    }
  };

  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <h1 className="form__section__title">Group Details</h1>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="groupName" className="form__label">
                    Group Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="groupName"
                    maxLength={30}
                    name="groupName"
                    value={formData.groupName}
                    onChange={handleChange}
                    className="form__input form__input--sm"
                    placeholder="Group Name"
                  />
                </div>
                <div className="form__error">{formError.groupNameError}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="firstMessage" className="form__label">
                    Assistant<sup className="form__label__asterisk">*</sup>
                  </label>
                  <MultiSelectDropdown
                    id="assistant"
                    name="assistantId"
                    options={formattedAssistantList}
                    selectedValue={selectedAssistants}
                    onChange={handleChangeAssistantListData}
                  />
                </div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="members" className="form__label">
                    Group Members <span style={{ color: "red" }}> * </span>
                  </label>
                  <MultiSelectDropdown
                    id="members"
                    name="membersId"
                    options={formatedMembersList}
                    selectedValue={selectedMembers}
                    onChange={handleChangeMembers}
                  />
                </div>
              </div>
            </div>
            <div className="formRow">
              <div className="formCol">
                <div className="form__switchBtn">
                  <div className="form__switchBtn__option">
                    <label for="status" className="form__label">
                      Status
                    </label>
                    <div className="switchBtn">
                      <input
                        id="status"
                        type="checkbox"
                        className="toggle"
                        name="status"
                        checked={formData.status}
                        onChange={handleChange}
                      />
                      <label for="status">
                        <span className="on">ON</span>
                        <span className="off">OFF</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="btn__group">
              <button
                className="btn btn__white"
                type="button"
                onClick={onClickCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn__primary"
                type="submit"
                disabled={
                  hasChanged === false ||
                  !formData.groupName ||
                  !selectedMembers.length ||
                  formError.groupNameError
                }
                onClick={handleSubmit}
              >
                {isEditGroup ? "Update" : "Save"}
              </button>
            </div>
          </section>
        </div>
      </div>
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleUpdate}
          yes={"Update"}
          no={"Cancel"}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Update Changes!"
          message="Are you sure you want to update the changes?"
        />
      ) : (
        ""
      )}
      {hasChangedModel ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={() => {
            setHasChangedModel(false);
          }}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : null}
    </div>
  );
};
